import { render, staticRenderFns } from "./EditOrderIntermediary.vue?vue&type=template&id=74ace1a8&"
import script from "./EditOrderIntermediary.vue?vue&type=script&lang=js&"
export * from "./EditOrderIntermediary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports